// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__11nxZ","main":"Footer_main__3CODV","names":"Footer_names__m_alY","commentMessage":"Footer_commentMessage__2ZuSm","email":"Footer_email__26yOu"};